import { MINUTE } from '@sparelabs/time'

const POLLING_THRESHOLD_SECONDS = 2 * MINUTE

export const isWithinPollingThreshold = (matchCutoffTs: number, currentTs: number) =>
  matchCutoffTs - currentTs <= POLLING_THRESHOLD_SECONDS
